import SearchResultsPanel from './SearchResultsPanel';

export default SearchResultsPanel;
